import { render } from "./PortafolioView.vue?vue&type=template&id=534c220a&scoped=true"
import script from "./PortafolioView.vue?vue&type=script&lang=js"
export * from "./PortafolioView.vue?vue&type=script&lang=js"

import "./PortafolioView.vue?vue&type=style&index=0&id=534c220a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-534c220a"]])

export default __exports__